import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import UserService from '../../services/user-service/UserService'
import ErrorHandler from '../../utils/ErrorHandler'
import { Alert } from 'shards-react'
import AlertMessages from '../../utils/AlertMessages'
import ActionsService from '../../services/actions-service/ActionsService'
import CheckedActionsList from './checked-actions-list/CheckedActionsList'
import { BreadCrumbLayout } from '../../components/common/BreadCrumbLayout'
import { useParams } from 'react-router-dom'
import { useMountBreadCrumb } from '../../hooks/useMountBreadCrumb'

export default function MiniAppPrivilegiesView() {
    const defaultAlertValue = { alertArea: '', isVisible: false, message: '', theme: '' }
    const [isFetching, setIsFetching] = useState(false)
    const [alertConfig, setAlertConfig] = useState(defaultAlertValue)
    const [opennedDescription, setOpennedDescription] = useState(null)
    const [allActions, setAllActions] = useState([])
    const [checkedActions, setCheckedActions] = useState([])
    // const [hasPermissionsToAccess, setHasPermissionsToAccess] = useState(false)
    const params = useParams()
    const { email, slug } = params

    useEffect(() => {
        // checkedLoggedUserPermissions()
        findAllActions()

        // if (hasPermissionsToAccess) findCheckedActions(email, slug)
        // else window.location.pathname = '/applications/1'
        findCheckedActions(email, slug)
        // console.log('hasPermissionsToAccess', hasPermissionsToAccess)
    }, [])

    // const checkedLoggedUserPermissions = async () => {
    //     const res = await ActionsService.hasAction('manage_miniapp_devs', slug)
    //     setHasPermissionsToAccess(res)
    // }

    const findAllActions = async () => {
        const alertValues = { alertArea: '', isVisible: false, message: '', theme: '' }
        setIsFetching(true)

        try {
            const res = await UserService.findAllActions()
            setAllActions(res.data)
        } catch (error) {
            alertValues.theme = 'danger'
            alertValues.message = AlertMessages.messageOnFindAllActions(error?.response?.status)
            alertValues.isVisible = true

            ErrorHandler.handleError(error)
            setAlertConfig(alertValues)
            setAllActions([])
        } finally {
            setIsFetching(false)
        }
    }

    const findCheckedActions = async (email, slug) => {
        const alertValues = { alertArea: '', isVisible: false, message: '', theme: '' }
        setIsFetching(true)

        try {
            const res = await ActionsService.findCheckedActions(email, slug)
            setCheckedActions(res.data)
        } catch (error) {
            alertValues.theme = 'danger'
            alertValues.message = AlertMessages.messageOnFindCheckedActions(error?.response?.status)
            alertValues.isVisible = true

            ErrorHandler.handleError(error)
            setAlertConfig(alertValues)
            setCheckedActions([])
        } finally {
            setIsFetching(false)
        }
    }

    const isItemChecked = (action, checkedActions) => {
        return checkedActions && checkedActions.length > 0 && checkedActions.indexOf(action.toUpperCase()) >= 0
    }

    const handleToggleUserActions = name => {
        const actionList = [...checkedActions]
        const nameWithUpperCase = name.toUpperCase()
        const isRepeatedActions = actionList.includes(name || nameWithUpperCase)
        if (isRepeatedActions) {
            const index = actionList.indexOf(name)
            actionList.splice(index, 1)
        } else {
            actionList.push(name.toUpperCase())
        }
        setCheckedActions(actionList)
    }

    const toggle = description => {
        if (description === opennedDescription) setOpennedDescription(null)
        else setOpennedDescription(description)
    }

    const handleEditUserActions = async email => {
        const alertConfigToModify = { alertArea: 'UserActions', isVisible: true, message: '', theme: '' }

        try {
            const res = await UserService.editActions(email, checkedActions, slug)

            alertConfigToModify.message = AlertMessages.messageOnEditUserMiniAppActions(res.status)
            alertConfigToModify.theme = 'success'

            setCheckedActions(res.data.actions)
        } catch (error) {
            alertConfigToModify.message = AlertMessages.messageOnEditUserMiniAppActions(
                error.response && error.response.status,
            )
            alertConfigToModify.theme = 'danger'
        } finally {
            setAlertConfig(alertConfigToModify)
        }
    }

    const mountBreadCrumb = () => {
        return <BreadCrumbLayout initialName={email} textRoute="Actions do desenvolvedor" />
    }

    const actions = { isItemChecked, handleToggleUserActions, toggle, handleEditUserActions }
    const options = { allActions, email, slug, checkedActions, opennedDescription }
    const informations = { isFetching }

    const { setBreadCrumb } = useMountBreadCrumb()

    useEffect(() => {
        setBreadCrumb(mountBreadCrumb())
    }, [])

    return (
        <React.Fragment>
            {alertConfig.isVisible && <Alert theme={alertConfig.theme}>{alertConfig.message}</Alert>}
            <CheckedActionsList actions={actions} options={options} informations={informations} />
        </React.Fragment>
    )
}

MiniAppPrivilegiesView.propTypes = {
    match: PropTypes.object,
    params: PropTypes.object,
    location: PropTypes.object,
    informations: PropTypes.object,
    history: PropTypes.object,
}
